export default "__VITE_ASSET__CpFW8nYz__"